export default __webpack_public_path__ + "static/media/ECart.58561601.png";